export type {
  Cart,
  CartItem,
  CartCoupon,
  CurrencyInfo,
  ProductPackage,
  ProductPackageProduct,
} from '@src/core/buyerApiClient';
export type { DetailedSaleItem, SaleTariff } from '@src/domains/sales';

import type { ProductPackage, ProductPackageProduct } from '@src/core/buyerApiClient';

export interface PriceSummary {
  total: number;
  discount?: number;
  previousPrice?: number;
}

export interface PackageGroup<T> {
  productPackage: ProductPackage;
  items: T[];
}

export interface PackageItem {
  productPackageUnitId: string | null;
  productPackageProduct?: ProductPackageProduct | null;
}

export const enum CartErrorsEnum {
  TARIFF_VERIFICATION_VALIDATION_NOT_FULFILLED = 'tariffVerificationValidationNotFulfilled',
}
